import { getFileExtension } from "lib/actions/files";
import { parseContentUri } from "./parseContentUri";
import { isExtensionSupported } from "lib/actions/pdftron/isExtensionSupported";
import { KeyframeViewer } from "lib/contexts/ProjectContexts/SelectedViewerContext";

/**
 * @param fileNameLegacy - Fallback file name to determine extension if contentUri does not
 * provide it. Should only be provided when checking for non Cesium viewer types.
 */
export function getViewerType(
  contentUri: string,
  fileNameLegacy: string = null,
) {
  const { type, value } = parseContentUri(contentUri);
  if (type === "tileset" || type === "cubeset") return KeyframeViewer.Cesium;
  if (type === "file") {
    const extension =
      getFileExtension(value) ?? getFileExtension(fileNameLegacy);
    if (isExtensionSupported(extension)) return KeyframeViewer.PdfTron;
  }
  return null;
}
